import { ROUTES } from '@shared/utils';
import { isSelfExcluded } from '../../helpers/isSelfExcluded';
import type { Session } from '../../types';

type AuthGateOutcome =
  { type: 'allow' } | { type: 'wait' } | { type: 'profileRedirect' } | { type: 'signIn' } | { type: 'selfExcludedRedirect' } | { type: 'fraudExcludedRedirect' };

const SELF_EXCLUDED_PATH = '/time-off';

function resolveAuthGate(input: {
  pathname: string;
  searchParams: Pick<URLSearchParams, 'get'>;
  session: Session;
  registerRedirectUrl: string;
  isLoggedInRequired: boolean;
  isRegistrationAuthComplete?: boolean;
  isAwaitingRegistrationSuccessRedirect: boolean;
}): AuthGateOutcome {
  if (isSelfExcluded(input.searchParams)) {
    if (input.pathname.startsWith(SELF_EXCLUDED_PATH)) {
      return { type: 'allow' };
    } else {
      return { type: 'selfExcludedRedirect' };
    }
  }

  if (input.searchParams.get('login_success') === 'false' && input.pathname !== ROUTES.HOME) {
    return { type: 'fraudExcludedRedirect' };
  }

  if (input.session.status === 'uninitialised' || input.session.status === 'loading') {
    if (input.isLoggedInRequired) {
      return { type: 'wait' };
    }
    return { type: 'allow' };
  }

  const isRegisterRoute = input.pathname.startsWith(ROUTES.REGISTER);
  if (isRegisterRoute && input.session.status === 'authenticated') {
    if (input.isRegistrationAuthComplete || input.isAwaitingRegistrationSuccessRedirect) {
      return { type: 'allow' };
    }
    return { type: 'profileRedirect' };
  }

  if (input.isLoggedInRequired && input.session.status === 'unauthenticated') return { type: 'signIn' };

  return { type: 'allow' };
}

export { resolveAuthGate };
